<template>
  <div class="startup-overview">
    <div class="row">
      <div class="col-md-12">
        <OverviewInfoEditor v-if="editable" />
        <OverviewInfo v-if="!editable" />
      </div>
    </div>

    <div v-show="showCurrentRound" class="row">
      <div class="col-md-12">
        <OverviewCurrentRound :editable="editable" />
      </div>
    </div>

    <div v-show="showPreviousRounds" class="row">
      <div class="col-md-12">
        <OverviewPreviousRounds :editable="editable" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import OverviewInfoEditor from './OverviewInfoEditor.vue'
import OverviewInfo from './OverviewInfo.vue'
import OverviewCurrentRound from './OverviewCurrentRound.vue'
import OverviewPreviousRounds from './OverviewPreviousRounds.vue'

export default {
  components: {
    OverviewInfo,
    OverviewCurrentRound,
    OverviewPreviousRounds,
    OverviewInfoEditor,
  },
  props: {
    editable: { type: Boolean, default: false },
  },
  computed: {
    showPreviousRounds() {
      return (
        this.editable ||
        (!this.editable &&
          this.startup.previous_rounds &&
          this.startup.previous_rounds.length)
      )
    },
    showCurrentRound() {
      const s = this.startup
      const showInPreview = s && s.round_size
      return this.editable || showInPreview
    },
    ...mapState({
      startup: (state) => state.startupProfile.startup,
    }),
  },
}
</script>
